import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./TestimonialsContent.css";

function TestimonialsContent() {
  const [data, setData] = useState(true);
  const [selected, setSelected] = useState(1);
  return (
    <>
      <div className="testimonial-extra-row">
        <div className="testimonial-row row1">
          <div className="testimonial-box">
            {data === "TestimonialReview2" ? (
              <div className="testi-content-review">
                <img
                  src="images/Home/left-quote.png"
                  alt="left-quote"
                  className="left-quote"
                />
                <h3>HTW Edge:</h3>
                <p>
                  The HTW team is fantastic as they gave us a great opportunity
                  to upscale and up-skill on Al tech and helped us in getting
                  certified. I am delighted to be a part of this program and got
                  100% fruit out of it. I am thankful to everyone from the HTW
                  Edge team for conducting this program and making it a grand
                  success - Divya Balasa
                </p>
                <img
                  src="images/Home/right-quote.png"
                  alt="right-quote"
                  className="right-quote"
                />
              </div>
            ) : data === "TestimonialReview3" ? (
              <div className="testi-content-review">
                <img
                  src="images/Home/left-quote.png"
                  alt="left-quote"
                  className="left-quote"
                />
                <h3>Quantum Impact Program:</h3>
                <p>
                  I always wanted to upskill myself technically. QIP provided
                  the opportunity to enhance our knowledge and upskills myself
                  to get motivated - Thangamalar Anitha
                </p>
                <img
                  src="images/Home/right-quote.png"
                  alt="right-quote"
                  className="right-quote"
                />
              </div>
            ) : data === "TestimonialReview4" ? (
              <div className="testi-content-review">
                <img
                  src="images/Home/left-quote.png"
                  alt="left-quote"
                  className="left-quote"
                />
                <h3>Quantum Impact Program:</h3>
                <p>
                  I always wanted to learn Machine learning topics in an
                  organized manner, this is exactly what we can get here. It
                  starts with the basics and slowly moves towards the important
                  topics- Shatarupa Nath
                </p>
                <img
                  src="images/Home/right-quote.png"
                  alt="right-quote"
                  className="right-quote"
                />
              </div>
            ) : data === "TestimonialReview5" ? (
              <div className="testi-content-review">
                <img
                  src="images/Home/left-quote.png"
                  alt="left-quote"
                  className="left-quote"
                />
                <h3>CyberHER:</h3>
                <p>
                  The CyberHER program was a great initiative to get more people
                  educated and familiarize with the security concepts and secure
                  coding practices. This program gave a good start, for everyone
                  from any background to get to speed and gain confidence to
                  understand all the phases of identifying and mitigating
                  threats and implementing secure practices across the software
                  development lifecycle - Mythili Viswanathan
                </p>
                <img
                  src="images/Home/right-quote.png"
                  alt="right-quote"
                  className="right-quote"
                />
              </div>
            ) : data === "TestimonialReview6" ? (
              <div className="testi-content-review">
                <img
                  src="images/Home/left-quote.png"
                  alt="left-quote"
                  className="left-quote"
                />
                <h3>CyberHER:</h3>
                <p>
                  Cyber Her initiative serves as bastions for enhancing
                  understanding of information security, delving into both
                  theoretical concepts and practical applications. This program
                  has empowered me with the knowledge and skills necessary to
                  navigate the ever-evolving landscape of the cybersecurity.
                  Thank you for giving me this opportunity - Swati Parakh
                </p>
                <img
                  src="images/Home/right-quote.png"
                  alt="right-quote"
                  className="right-quote"
                />
              </div>
            ) : (
              <div className="testi-content-review">
                <img
                  src="images/Home/left-quote.png"
                  alt="left-quote"
                  className="left-quote"
                />
                <h3>HTW Edge:</h3>
                <p>
                  Despite of hectic schedules, HTW Edge team made the entire
                  engagement look very simple, and we appreciate all your
                  collaboration, valuable learning resources, and outstanding
                  assistance - Geetha Magge
                </p>
                <img
                  src="images/Home/right-quote.png"
                  alt="right-quote"
                  className="right-quote"
                />
              </div>
            )}
          </div>
        </div>
        <div className="testimonial-row row2">
          <div className="testimonial-box">
            <div
              className={selected == 1 ? "on-highlight" : "on-normal"}
              onClick={() => {
                setData("TestimonialReview");
                setSelected(1);
              }}
            >
              <div className="testi-person-wrap">
                <img
                  src="images/Home/testimonial-arrow.png"
                  alt="arrow"
                  className="testimonial-arrow"
                />
                <div className="testi-person-row row1">
                  <div className="testi-person-box">
                    <img
                      src="images/Home/testimonial-img1.png"
                      alt="testimonial-avatar"
                      className="testimonial-avatar"
                    />
                  </div>
                </div>
                <div className="testi-person-row row2">
                  <div className="testi-person-box">
                    <h3>Geetha Magge</h3>
                    <p>Tech Architecture Sr Manager</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={selected == 2 ? "on-highlight" : "on-normal"}
              onClick={() => {
                setData("TestimonialReview2");
                setSelected(2);
              }}
            >
              <div className="testi-person-wrap">
                <img
                  src="images/Home/testimonial-arrow.png"
                  alt="arrow"
                  className="testimonial-arrow"
                />
                <div className="testi-person-row row1">
                  <div className="testi-person-box">
                    <img
                      src="images/Home/testimonial-img2.png"
                      alt="testimonial-avatar"
                      className="testimonial-avatar"
                    />
                  </div>
                </div>
                <div className="testi-person-row row2">
                  <div className="testi-person-box">
                    <h3>Divya Balasa</h3>
                    <p>Tech Architecture Manager</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={selected == 3 ? "on-highlight" : "on-normal"}
              onClick={() => {
                setData("TestimonialReview3");
                setSelected(3);
              }}
            >
              <div className="testi-person-wrap">
                <img
                  src="images/Home/testimonial-arrow.png"
                  alt="arrow"
                  className="testimonial-arrow"
                />
                <div className="testi-person-row row1">
                  <div className="testi-person-box">
                    <img
                      src="images/Home/testimonial-img3.png"
                      alt="testimonial-avatar"
                      className="testimonial-avatar"
                    />
                  </div>
                </div>
                <div className="testi-person-row row2">
                  <div className="testi-person-box">
                    <h3>Thangamalar Anitha</h3>
                    <p>Packaged App Development Senior Analyst</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={selected == 4 ? "on-highlight" : "on-normal"}
              onClick={() => {
                setData("TestimonialReview4");
                setSelected(4);
              }}
            >
              <div className="testi-person-wrap">
                <img
                  src="images/Home/testimonial-arrow.png"
                  alt="arrow"
                  className="testimonial-arrow"
                />
                <div className="testi-person-row row1">
                  <div className="testi-person-box">
                    <img
                      src="images/Home/testimonial-img4.png"
                      alt="testimonial-avatar"
                      className="testimonial-avatar"
                    />
                  </div>
                </div>
                <div className="testi-person-row row2">
                  <div className="testi-person-box">
                    <h3>Shatarupa Nath</h3>
                    <p>Data Eng, Mgmt & Governance Specialist</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={selected == 5 ? "on-highlight" : "on-normal"}
              onClick={() => {
                setData("TestimonialReview5");
                setSelected(5);
              }}
            >
              <div className="testi-person-wrap">
                <img
                  src="images/Home/testimonial-arrow.png"
                  alt="arrow"
                  className="testimonial-arrow"
                />
                <div className="testi-person-row row1">
                  <div className="testi-person-box">
                    <img
                      src="images/Home/testimonial-img5.png"
                      alt="testimonial-avatar"
                      className="testimonial-avatar"
                    />
                  </div>
                </div>
                <div className="testi-person-row row2">
                  <div className="testi-person-box">
                    <h3>Mythili Viswanathan</h3>
                    <p>Software Prod & Plat Eng Manager</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={selected == 6 ? "on-highlight" : "on-normal"}
              onClick={() => {
                setData("TestimonialReview6");
                setSelected(6);
              }}
            >
              <div className="testi-person-wrap">
                <img
                  src="images/Home/testimonial-arrow.png"
                  alt="arrow"
                  className="testimonial-arrow"
                />
                <div className="testi-person-row row1">
                  <div className="testi-person-box">
                    <img
                      src="images/Home/testimonial-img6.png"
                      alt="testimonial-avatar"
                      className="testimonial-avatar"
                    />
                  </div>
                </div>
                <div className="testi-person-row row2">
                  <div className="testi-person-box">
                    <h3>Swati Parakh</h3>
                    <p>Packaged App Development Sr Manager</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TestimonialsContent;
